var constants = require('../constants').map;

function BingMap(nodeElement, credentials, opts) {
  // Custom Pin and styles to provide via labels
  // "mapPinAnchorX": 15,
  // "mapPinAnchorY": 27,
  // "mapPinColorDefault": "#5d6061",
  // "mapPinColorHover": "#f30000",
  // "mapPinColorSelected": "#E5E5E5",
  // "mapPinColorPreferred": "#2198DC",
  // "mapPinContent": "<svg xmlns='http://www.w3.org/2000/svg' height='45' width='30'><g><path d='M12.5,39C12.5,39,0,23.8,0,13.6C0,6,5.5,0,12.5,0S25,6,25,13.6C25,23.8,12.5,39,12.5,39z'/></g></svg>",
  // "mapPinTextOffsetX": -3,
  // "mapPinTextOffsetY": 8,
  // "bingMapsDealerWebsite": "Dealer Website",
  // "bingMapsDealerDirections": "Get Directions",
  // "mapInfoboxDealerProps": "Address,City,Name,State,WebAddress,ZipCode",
  // "mapInfoboxLabels": "bingMapsDealerDirections,bingMapsDealerWebsite",
  // "mapInfoboxTemplate": "<div class='pin-infobox'><div class='infobox'><div class='infobox-arrow'></div><h2 class='dealer-name'>{Name}</h2><div><div class='infobox-website'><a class='dealer-cta' href='{WebAddress}' target='_blank'><span>{bingMapsDealerWebsite}</span></a></div><div class='infobox-directions'><a class='dealer-cta' href='http://bing.com/maps/default.aspx?rtp=~adr.{Address} {City}, {State} {ZipCode}' target='_blank'><span>{bingMapsDealerDirections}</span></a></div></div></div></div>"
  var i;
  var keys;
  var options = opts || {};

  this.API_ENDPOINT = constants.API_ENDPOINT;
  this.CALLBACK = constants.DEFAULT_LOAD_CALLBACK;
  this.nodeElement = nodeElement;
  this.credentials = credentials;
  this.options = constants.DEFAULT_OPTIONS;
  this.origin = null;
  this.points = null;
  this.timeout = null;

  for (i = 0, keys = Object.keys(options); i < keys.length; i++) {
    this.options[keys[i]] = options[keys[i]];
  }
}

function CustomOverlay(element, containerClass) {
  this.element = element;
  this.containerClass = containerClass;
}

function triggerEvent(eventName, data) {
  var event;

  if (typeof window.CustomEvent === 'function') {
    event = new CustomEvent(eventName, {
      detail: data,
    });
  } else {
    // old API for IE11
    // polyfilling based on
    // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, data);
  }

  window.dispatchEvent(event);
}

function pinSelect(e) {
  var data = {
    index: e.target.customIndex,
  };

  triggerEvent('bingmapspinselected', data);
}

BingMap.prototype.isLoaded = function isLoaded() {
  return window.Microsoft && window.Microsoft.Maps;
};

BingMap.prototype.isCreated = function isCreated() {
  return this.created;
};

BingMap.prototype.load = function load() {
  var script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = this.API_ENDPOINT + '&callback=' + this.CALLBACK;

  document.body.appendChild(script);
};

BingMap.prototype.create = function create() {
  var Microsoft = window.Microsoft;
  var centerLocation = new Microsoft.Maps.Location(
    constants.DEFAULT_LAT, constants.DEFAULT_LON
  );

  this.map = new Microsoft.Maps.Map(this.nodeElement, {
    credentials: this.credentials,
    mapTypeId: Microsoft.Maps.MapTypeId.road,
    center: centerLocation,
    disableScrollWheelZoom: this.options.disableScrollWheelZoom,
    enableClickableLogo: this.options.enableClickableLogo,
    showCopyright: this.options.showCopyright,
    showLocateMeButton: this.options.showLocateMeButton,
    showMapTypeSelector: this.options.showMapTypeSelector,
    showScalebar: this.options.showScalebar,
    showZoomButtons: this.options.showZoomButtons,
    zoom: this.options.zoom,
  });

  this.created = true;

  this.infobox = new Microsoft.Maps.Infobox(centerLocation, {
    visible: false,
  });

  CustomOverlay.prototype = new Microsoft.Maps.CustomOverlay({ beneathLabels: false });
  CustomOverlay.prototype.onAdd = function onAdd() {
    var container = document.createElement('div');
    container.classList.add(this.containerClass);
    container.appendChild(this.element);
    this.setHtmlElement(container);
  };

  this.infobox.setMap(this.map);
};

BingMap.prototype.updatePins = function updatePins(points, zoom, icons) {
  var self = this;

  var bestview;
  var locations = [];
  var Microsoft = window.Microsoft;
  var mapOptions;
  var pin;
  var originLocation;

  if (points.length === 0) {
    return;
  }

  self.points = points;

  points.forEach(function addPoint(point, i) {
    var icon;

    if (icons.iconImage) {
      icon = icons.iconImage;
    } else if (point.preferred) {
      icon = icons.PREFERRED;
    } else if (point.selected) {
      icon = icons.SELECTED;
    } else {
      icon = icons.DEFAULT;
    }

    locations[i] = new Microsoft.Maps.Location(point.Latitude, point.Longitude);
    pin = new Microsoft.Maps.Pushpin(locations[i], {
      text: (i + 1).toString(),
      icon: icon,
      // anchors the pin to the tip of the icon with 36 by 30 dimensions
      anchor: new Microsoft.Maps.Point(
        icons.anchorX, icons.anchorY
      ),
      textOffset: new Microsoft.Maps.Point(
        icons.textOffsetX, icons.textOffsetY
      ),
    });

    pin.customIndex = i;

    Microsoft.Maps.Events.addHandler(pin, 'click', pinSelect);

    if (icons.HOVER) {
      Microsoft.Maps.Events.addHandler(pin, 'mouseover', function pinHover(e) {
        e.target.setOptions({
          icon: icons.HOVER,
        });
      });

      Microsoft.Maps.Events.addHandler(pin, 'mouseout', function pinHoverOut(e) {
        e.target.setOptions({
          icon: icons.DEFAULT,
        });
      });
    }

    self.map.entities.push(pin);
  });

  if (self.origin) {
    originLocation = new Microsoft.Maps.Location(
      self.origin.Latitude, self.origin.Longitude
    );

    locations.push(originLocation);
  }

  bestview = Microsoft.Maps.LocationRect.fromLocations(locations);

  mapOptions = points.length === 1 && !self.origin ? {
    center: bestview.center,
    zoom: zoom || constants.DEFAULT_OPTIONS.maxZoom,
  } : {
    bounds: bestview,
  };

  mapOptions.padding = constants.DEFAULT_OPTIONS.padding;

  self.map.setView(mapOptions);
};

BingMap.prototype.setOrigin = function setOrigin(data) {
  var Microsoft = window.Microsoft;
  var self = this;
  var points;
  var bestview;

  Microsoft.Maps.loadModule('Microsoft.Maps.Search', function search() {
    var searchManager = new Microsoft.Maps.Search.SearchManager(self.map);

    var requestOptions = {
      where: data.zip || data.city + ', ' + data.state,
      callback: function cb(answer) {
        if (answer.results && answer.results.length) {
          self.origin = {
            Latitude: answer.results[0].location.latitude,
            Longitude: answer.results[0].location.longitude,
          };

          if (self.points) {
            points = self.points.concat(self.origin);
            bestview = self.getBestView(points);

            self.map.setView({
              bounds: bestview,
              padding: constants.DEFAULT_OPTIONS.padding,
            });
          }
        }
      },
    };

    searchManager.geocode(requestOptions);
  });
};

BingMap.prototype.getBestView = function getBestView(points) {
  var Microsoft = window.Microsoft;
  var locations = [];
  if (points !== undefined) {
    points.forEach(function addPoint(point) {
      locations.push(
        new Microsoft.Maps.Location(point.Latitude, point.Longitude)
      );
    });
  }

  return Microsoft.Maps.LocationRect.fromLocations(locations);
};

BingMap.prototype.setView = function setView(mapOptions) {
  var self = this;

  self.map.setView(mapOptions);

  // we create a new center that is just slightly off, so visually
  // you don't see the center change, but underneath we are actually changing
  // it, triggering a refresh of the map
  // eslint-disable-next-line no-param-reassign
  mapOptions.center.latitude -= 0.0000001;

  // center hack to force the map to refresh the pins on the map
  // for some reason after setting new bounds only the previously
  // visible pin is displayed (and sometimes the terrain is also
  // not displayed, making the map look like it's showing just the ocean).

  if (this.timeout) {
    clearTimeout(this.timeout);
  }

  this.timeout = setTimeout(function refresh() {
    self.map.setView({
      padding: constants.DEFAULT_OPTIONS.padding,
      center: mapOptions.center,
    });
  }, 300);
};

BingMap.prototype.resetOrigin = function reset() {
  this.origin = null;
};

BingMap.prototype.setCustomOverlay = function setCustomOverlay(element,
  containerClass) {
  return new CustomOverlay(element, containerClass);
};

BingMap.prototype.clear = function clear() {
  this.map.entities.clear();
};

BingMap.prototype.setInfobox = function setInfobox(entity, content) {
  var self = this;
  var Microsoft = window.Microsoft;
  var centerLocation = new Microsoft.Maps.Location(
    entity.Latitude, entity.Longitude
  );

  self.infobox.setOptions({
    location: centerLocation,
    htmlContent: content,
    visible: true,
  });
};

BingMap.prototype.closeInfobox = function closeInfoBox() {
  var self = this;

  if (self.infobox !== undefined) {
    self.infobox.setOptions({ visible: false });
  }
};

window.bingMapsLoaded = function bingMapsLoaded() {
  triggerEvent('bingmapsloaded');
};

module.exports = BingMap;
